import React, { useMemo } from 'react';
type Props = {
  count?: number;
  className?: string;
};
export const StarField: React.FC<Props> = ({
  count = 60,
  className = ''
}) => {
  const stars = useMemo(() => Array.from({
    length: count
  }).map((_, i) => ({
    id: i,
    top: Math.random() * 100,
    left: Math.random() * 100,
    size: Math.random() * 2 + 0.5,
    delay: Math.random() * 4,
    opacity: Math.random() * 0.6 + 0.2
  })), [count]);
  return <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} data-id="element-469">
      {stars.map(s => <div key={s.id} className="star absolute rounded-full" style={{
      top: `${s.top}%`,
      left: `${s.left}%`,
      width: `${s.size}px`,
      height: `${s.size}px`,
      background: s.id % 5 === 0 ? '#D4AF7A' : '#F5EFE6',
      opacity: s.opacity,
      animationDelay: `${s.delay}s`,
      boxShadow: s.id % 5 === 0 ? '0 0 6px rgba(212,175,122,0.6)' : '0 0 4px rgba(245,239,230,0.4)'
    }} data-id="element-470" />)}
    </div>;
};